import { LocationRefService } from './../../../shared/services/LocationRef.service';
import { CartService } from 'projects/shared/services/cart.service';
import { AuthService } from './../../../shared/services/auth.service';
import { ExchangeService } from './../../../shared/services/exchange.service';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import {
  AfterViewInit,
  Component,
  effect,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2,
  Signal,
  untracked,
} from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { IUser } from 'projects/shared/models/interfaces/user.model';
import { Subscription, catchError, debounceTime, distinctUntilChanged, filter, forkJoin, map, noop, of, skip, take, tap } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { LinksService } from 'projects/shared/services/links.service';
import { CanonicalService } from 'projects/shared/services/canonical.service';
import { LightModeService } from './+shared/services/light-mode.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './+shared/services/language.service';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { BrowserService } from 'projects/shared/services/browser.service';
import { WebSettingService } from 'projects/shared/services/web-setting.service';
import { IWebSetting } from 'projects/shared/models/interfaces/IWebSetting';
import { TicketSocketService } from 'projects/shared/services/ticket-socket.service';
import { TargetAlertsService } from './+shared/services/targe-alerts.service';
import { makeQueryParams } from './../../../admin/src/app/shared/helpers/makeQueryParams';
import { MessageService } from 'primeng/api';
import { CrispChatService } from 'projects/shared/services/crisp-chat.service';
import { CookieService } from 'ngx-cookie-service';
import { MobileToasterService } from 'projects/shared/components/mobile-toaster/services/mobile-toaster.service';
import { AnalyticsTracker } from './+shared/trackers/analytics.tracker';
import { AnalyticsService } from './+shared/services/analytics.service';
import { StopAutoScrollService } from './modules/categories/services/stop-auto-scroll.service';
import { DesktopToaster } from 'projects/shared/services/desktop-toaster.service';
import { SeoService } from 'projects/shared/services/seo.service';
import { UrlUtility } from 'projects/shared/services/url.utility';
import { Store } from '@ngrx/store';
import { SelectRegionalLanguage } from './layout/navbar/components/navbar-header/partials/nav-regional/store/regional-setting.selectors';
import { SelectUser, SelectUserStatus } from './modules/user-settings/components/profile/store/profile.selectors';
import { UserActions } from './modules/user-settings/components/profile/store/profile.actions';
import { CancelRequestsService } from './+shared/services/cancel-requests.service';
import { AppInitializerService } from './+shared/services/app-initializer.service';


declare let dataLayer: any[];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  isVisible: boolean = false;
  showHeader = true;
  user!: IUser | null;

  showLoading = true;
  subscription: Subscription = new Subscription();
  lightMood = false;

  activeCurrency!: string;
  arabic = false;
  webSettingConfig!: IWebSetting;

  language$: Signal<string> = this._store.selectSignal(SelectRegionalLanguage);

  maintenanceIsActive = false;

  user$ = this._store.selectSignal(SelectUser);
  userLogin$ = this._store.selectSignal(SelectUserStatus)


  _analyticsTracker = new AnalyticsTracker();
  constructor(
    public router: Router,
    private authServ: AuthService,
    private storeChangeServ: StoreChangesService,
    private exchangeServ: ExchangeService,
    private renderer: Renderer2,
    private linksService: LinksService,
    private lightModeService: LightModeService,
    private _languageService: LanguageService,
    private browserService: BrowserService,
    private _targetAlertsService: TargetAlertsService,
    private _messageService: MessageService,
    private _crispChatService: CrispChatService,
    private _analyticsService: AnalyticsService,
    private canonicalService: CanonicalService,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private document: Document,
    private webSettingService: WebSettingService,
    private _desktopToaster: DesktopToaster,
    private seoService: SeoService,
    private urlUtility: UrlUtility,
    private _store: Store,
    private _cancelRequestsService: CancelRequestsService,
    private appInitializer: AppInitializerService
  ) {

    effect(() => {
      const lang = this.language$();
      const isLoggedIn = this.userLogin$();
      const user = this.user$();

      this.switchLanguage(lang ?? 'en');
    })
    this.onlineAuth();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationError) {
        if (event.error.name === 'ChunkLoadError') {
          if (typeof window !== 'undefined') {
            window.location.reload();
          }
        }
      }
      if (event instanceof NavigationEnd) {
        if (typeof window !== 'undefined' && (window as any).dataLayer) {
          (window as any).dataLayer.push({
            event: 'pageview',
            pagePath: event.urlAfterRedirects
          });
        }
      }
    });

  }

  onlineAuth() {
    let params: any;

    if (this.browserService.getLocation()) params = this.extractQueryParams(location.href)
    if (this.browserService.getSessionStorage() && params.token) sessionStorage.setItem('token', params.token)
  }
  extractQueryParams(url: string) {
    const queryString = url?.split('?')[1]?.split('#')[0]; // Get query parameters part
    const params = new URLSearchParams(queryString);
    return Object.fromEntries(params.entries());
  }
  public throwTestError(): void {
    throw new Error("Sentry Test Error");
  }

  changeSiteMode() {
    this.lightModeService.lightMood.subscribe(
      res => {
        this.lightMood = res;
      }
    )
  }

  ngOnInit(): void {

    this._crispChatService.onInit();
    // this.getTargetAlerts();

    const localStorageBr = this.browserService.getLocalStorage();

    if (localStorageBr) {
      localStorage.removeItem("mainCategoryList");
    }
    const windowBr = this.browserService.getWindow();
    if (windowBr) {
      this.scrollTop();
    }
    this.changeSiteMode()

    this.metaPixel()

    this._desktopToaster.desktopToaster$.pipe(
      filter(data => data !== null),
      tap(
        data => {
          this._messageService.add(data)
        }
      )
    ).subscribe()
    
    this.maintenanceMode()

    // ✅ Use pre-loaded data from APP_INITIALIZER
    this.useCoreData();

  }

  maintenanceMode() {
    this._cancelRequestsService.maintenanceModeData.pipe(
      filter( res => res !== null),
      tap(
        res => {
          if (res) {
            this.maintenanceIsActive = true;
            console.log('this.maintenanceIsActive: ', this.maintenanceIsActive);
          }
        }
      )
    ).subscribe()
  }

  switchLanguage(lang: string) {
    const isAr = lang === 'ar';
    this.renderer.setAttribute(this.document.documentElement, 'lang', isAr ? 'ar' : 'en');
    this.renderer.setAttribute(this.document.documentElement, 'dir', isAr ? 'rtl' : 'ltr');
  }


  metaPixel() {
    this._analyticsService.initialize('6580004642019541');

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => {
          this._analyticsTracker.viewPage(this.browserService.getLocation()?.pathname!);
        }, 100);
      });
  }

  webSetting() {
    this.webSettingService.getWebsetting().subscribe(response => {
      console.log('response: ', response);
      this.webSettingConfig = response
      this.storeChangeServ.setWalletShow(this.webSettingConfig.hide_wallet)
      this.updateMetaTags();
      if (isPlatformServer(this.platformId)) {
        this.addStructuredData();
      }
    })
  }
  scrollTop() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        window.scroll(0, 0);
      });
  }

  handlingTranslateWhenStart() {
    this.storeChangeServ.getUser().pipe(
      debounceTime(0),
      tap(user => {
        if (!user) {
          this.setTranslateLocalstorgeAndDir()
        }
      }),
      filter(user => user !== null),
      tap(
        res => {
          this.user = res;
          if (this.user) {
            this._languageService.arabic.next(this.user.language == 'ar');
            this.setTranslateLocalstorgeAndDir()
          }
        }
      )
    ).subscribe()
  }

  setTranslateLocalstorgeAndDir() {
    if (!isPlatformBrowser(this.platformId)) return;

    let body: HTMLElement = document.querySelector('.app')!;
    let swiper = document.querySelector('.swiper-wrapper');

  }

  validateUser() {
    if (!this.userLogin$() && this.user$()._id) {
      this._store.dispatch(UserActions.userLogin({ login: true }))
    } else if (this.userLogin$() && !this.user$()._id) {
      this._store.dispatch(UserActions.userLogin({ login: true }))
    } else {
      this.subscription.add(
        this.authServ.validate().subscribe({
          next: (response) => {
            this._store.dispatch(UserActions.getUser({ data: response }))
            this._store.dispatch(UserActions.userLogin({ login: true }))
            this.user = response;
            this.storeChangeServ.setUser(response);
            this.authServ.updateUserShop(response);
            const sessionStorageBr = this.browserService.getSessionStorage();
            if (sessionStorageBr) {
              sessionStorage.setItem('userExist', 'true')
            }
            this.handlingTranslateWhenStart()
            this.onLoopComplete()
          },
          error: (response) => {
            console.log('response: ', response);
            this._store.dispatch(UserActions.userLogin({ login: false }))
            const sessionStorageBr = this.browserService.getSessionStorage();
            if (sessionStorageBr) {
              sessionStorage.setItem('userExist', 'false')
            }
            this.handlingTranslateWhenStart()
            this.onLoopComplete()
          }
        })
      );
    }
  }

  getExchangeRate() {
    this.subscription.add(
      this.exchangeServ.getUserExchange().subscribe((exchange) => {
        this.storeChangeServ.setExchange(exchange);
      })
    );
  }

  onLoopComplete(): void {
    this.showLoading = false;
    this._languageService.onLoadComplete.next(false)
  }



  updateMetaTags() {
    if (!this.webSettingConfig) return;

    const title = this.webSettingConfig.title?.en || 'Card4Games';
    const description = this.webSettingConfig.meta_description?.en || 'Card4Games - Digital Gaming Cards Store';
    const keywords = this.webSettingConfig.meta_keyword?.en || 'gaming cards, gift cards, subscriptions';
    const image = this.webSettingConfig.logo || this.urlUtility.buildUrl(this.linksService.baseUrl, undefined, 'assets/logo-web-2.png');
    const url = this.urlUtility.buildUrl(this.linksService.baseUrl, 'en');

    this.seoService.setSeo({
      title,
      description,
      keywords,
      image,
      url,
      type: 'website',
      locale: 'en'
    });
  }

  addStructuredData() {
    if (!this.webSettingConfig) return;

    const baseUrl = this.linksService.baseUrl;

    const structuredData = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': this.urlUtility.buildUrl(baseUrl, 'en', '#organization'),
          name: 'Card4Games',
          url: this.urlUtility.buildUrl(baseUrl, 'en'),
          logo: this.webSettingConfig.logo || this.urlUtility.buildUrl(baseUrl, undefined, 'assets/logo-web-2.png'),
          description: this.webSettingConfig.meta_description?.en || 'Card4Games Digital Gaming Store',
          sameAs: [
            this.linksService.facebook || '',
            this.linksService.instgram || ''
          ].filter(Boolean)
        },
        {
          '@type': 'WebSite',
          '@id': this.urlUtility.buildUrl(baseUrl, 'en', '#website'),
          url: this.urlUtility.buildUrl(baseUrl, 'en'),
          name: 'Card4Games',
          publisher: {
            '@id': this.urlUtility.buildUrl(baseUrl, 'en', '#organization')
          },
          potentialAction: {
            '@type': 'SearchAction',
            target: this.urlUtility.buildUrl(baseUrl, 'en', 'categories?search={search_term_string}'),
            'query-input': 'required name=search_term_string'
          }
        },
        {
          '@type': 'SiteLinksSearchBox',
          '@id': this.urlUtility.buildUrl(baseUrl, 'en', '#sitelinks-searchbox'),
          url: this.urlUtility.buildUrl(baseUrl, 'en'),
          potentialAction: {
            '@type': 'SearchAction',
            target: this.urlUtility.buildUrl(baseUrl, 'en', 'categories?search={search_term_string}'),
            'query-input': 'required name=search_term_string'
          }
        },
        {
          '@type': 'ItemList',
          '@id': this.urlUtility.buildUrl(baseUrl, 'en', '#navigation'),
          name: 'Main Navigation',
          itemListElement: [
            {
              '@type': 'SiteNavigationElement',
              position: 1,
              name: 'Home',
              url: this.urlUtility.buildUrl(baseUrl, 'en')
            },
            {
              '@type': 'SiteNavigationElement',
              position: 2,
              name: 'Categories',
              url: this.urlUtility.buildUrl(baseUrl, 'en', 'categories')
            },
            {
              '@type': 'SiteNavigationElement',
              position: 3,
              name: 'Blogs',
              url: this.urlUtility.buildUrl(baseUrl, 'en', 'blogs')
            },
            {
              '@type': 'SiteNavigationElement',
              position: 4,
              name: 'About Us',
              url: this.urlUtility.buildUrl(baseUrl, 'en', 'quick-links/about')
            },
            {
              '@type': 'SiteNavigationElement',
              position: 5,
              name: 'Contact Us',
              url: this.urlUtility.buildUrl(baseUrl, 'en', 'quick-links/contacts')
            },
            {
              '@type': 'SiteNavigationElement',
              position: 6,
              name: 'FAQ',
              url: this.urlUtility.buildUrl(baseUrl, 'en', 'quick-links/FAQ')
            },
            {
              '@type': 'SiteNavigationElement',
              position: 7,
              name: 'Privacy Policy',
              url: this.urlUtility.buildUrl(baseUrl, 'en', 'quick-links/privacy-policy')
            },
            {
              '@type': 'SiteNavigationElement',
              position: 8,
              name: 'Become a Reseller',
              url: this.urlUtility.buildUrl(baseUrl, 'en', 'quick-links/come-reseller')
            }
          ]
        }
      ]
    };

    this.seoService.setStructuredData(structuredData);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * ✅ Use data that was already loaded by APP_INITIALIZER
   */
  useCoreData(): void {
    const initData = this.appInitializer.initData;

    if (!initData) {
      console.warn('⚠️ No init data - using fallback');
      if (isPlatformBrowser(this.platformId)) {
        this.initCoreDataFallback();
      }
      return;
    }

    console.log('✅ Using APP_INITIALIZER data');

    if (initData.webSetting) {
      this.webSettingConfig = initData.webSetting;
      this.updateMetaTags();
      if (isPlatformServer(this.platformId)) {
        this.addStructuredData();
      }
    }

    if (initData.user.success && initData.user.response) {
      this._store.dispatch(UserActions.getUser({ data: initData.user.response }));
      this._store.dispatch(UserActions.userLogin({ login: true }));
      this.user = initData.user.response;
      if (this.browserService.getSessionStorage()) {
        sessionStorage.setItem('userExist', 'true');
      }
    } else {
      this._store.dispatch(UserActions.userLogin({ login: false }));
      if (this.browserService.getSessionStorage()) {
        sessionStorage.setItem('userExist', 'false');
      }
    }

    this.handlingTranslateWhenStart();
    this.onLoopComplete();
  }

  private initCoreDataFallback(): void {
    console.log('🔄 [FALLBACK] Loading...');
    this.subscription.add(
      forkJoin({
        exchange: this.exchangeServ.getUserExchange().pipe(catchError(() => of(null))),
        webSetting: this.webSettingService.getWebsetting().pipe(catchError(() => of(null))),
        user: this.authServ.validate().pipe(
          map(response => ({ success: true, response })),
          catchError(() => of({ success: false, response: null }))
        ),
      }).subscribe(({ exchange, webSetting, user }) => {
        if (exchange) this.storeChangeServ.setExchange(exchange);
        if (webSetting) {
          this.webSettingConfig = webSetting;
          this.storeChangeServ.setWalletShow(webSetting.hide_wallet);
          this.updateMetaTags();
        }
        if (user.success && user.response) {
          this._store.dispatch(UserActions.getUser({ data: user.response }));
          this._store.dispatch(UserActions.userLogin({ login: true }));
          this.user = user.response;
          this.storeChangeServ.setUser(user.response);
          this.authServ.updateUserShop(user.response);
        } else {
          this._store.dispatch(UserActions.userLogin({ login: false }));
        }
        this.handlingTranslateWhenStart();
        this.onLoopComplete();
      })
    );
  }
}
